import script from "./AtomImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AtomImage.vue?vue&type=script&setup=true&lang=ts"

import "./AtomImage.vue?vue&type=style&index=0&id=5e6bb2d3&scoped=true&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e6bb2d3"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QDialog,QCard,QBtn,QCardSection,QImg});qInstall(script, 'directives', {ClosePopup});
